import {
  TEACHING_PROCESS_LOADING,
  GET_TEACHING_TASK_LIST,
  ADD_TEACHING_TASK_LIST,
  ADD_TEACHING_TASK_LIST_FAILED,
  UPDATE_TEACHING_TASK_LIST,
  DELETE_TEACHING_TASK_LIST,
  DELETE_TEACHING_TASK_LIST_FAILED,
  GET_TEACHING_TASK_LIST_DETAIL,
  GET_TEACHING_PREVIEW,
  GET_TASKDATA_POSTS,
  GET_TEACHING_DETAILS
} from "../actions";

const initialState = {
  taskList: [],
  taskListDetail: {},
  isSuccess: false,
  tasksData: [],
  isDetailsView: null
};

const teachingReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEACHING_PROCESS_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_TEACHING_TASK_LIST:
      return {
        ...state,
        taskList: action.payload,
      };
    case GET_TEACHING_TASK_LIST_DETAIL:
      return {
        ...state,
        taskListDetail: action.payload,
      };
    case ADD_TEACHING_TASK_LIST:
      return {
        ...state,
        isSuccess: true,
      };
    case ADD_TEACHING_TASK_LIST_FAILED:
      return {
        ...state,
        isSuccess: false,
      };
    case UPDATE_TEACHING_TASK_LIST:
      return {
        ...state,
      };
    case DELETE_TEACHING_TASK_LIST:
      return {
        ...state,
        isSuccess: true,
      };
    case DELETE_TEACHING_TASK_LIST_FAILED:
      return {
        ...state,
        isSuccess: false,
      };
    case GET_TEACHING_PREVIEW:
      return {
        ...state,
        preview: action.data,
      };
    case GET_TASKDATA_POSTS:
      return {
        ...state,
        tasksData: action.data,
      }
    case GET_TEACHING_DETAILS:
      return {
        ...state,
        isDetailsView: action.payload,
      }
    default:
      return state;
  }
};

export default teachingReducer;
